import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import React, { memo, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import config from '../../../config';
import { logout } from '../../../ducks/auth.duck';
import routeConfiguration from '../../../routeConfiguration';
import useAppSelector from '../../../util/hooks/useAppSelector';
import { pathByRouteName } from '../../../util/routes';
import BoxSeparator from '../../BoxSeperator/BoxSeparator';

const SectionLoginComponent = ({ onClose }) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();

  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  const handleLogout = useCallback(() => {
    dispatch(logout()).then(() => {
      const path = pathByRouteName('LandingPage', routeConfiguration(), {}, intl.locale);
      if (config.dev) {
        navigate(path);
      } else if (typeof window !== 'undefined') {
        window.routerNavigate(path, { replace: true });
      }
    });
  }, [dispatch, navigate, intl]);

  return (
    <>
      <BoxSeparator />
      <Stack px={4} spacing={2}>
        {isAuthenticated ? (
          <Box display="flex" justifyContent="space-between" width="100%">
            <Button
              color="secondary"
              endIcon={<ChevronRightIcon />}
              fullWidth
              onClick={handleLogout}
              py={1}
              variant="outlined"
            >
              <FormattedMessage id="TopbarMobileMenu.logoutLink" />
            </Button>
          </Box>
        ) : null}
      </Stack>
    </>
  );
};

SectionLoginComponent.displayName = 'SectionLogin';
const SectionLogin = memo(SectionLoginComponent);
export default SectionLogin;
